"use client";
import { basePath } from "@/next.config";

export default function NotFound() {
  const redirectToHome = () => {
    window.location.href = "/";
  };
  return (
    <div className="h-screen flex items-center justify-center relative">
      <div className="container mx-auto text-center">
        <h1 className="text-4xl font-bold">404 - Page Not Found</h1>
        <p>Sorry, the page you are looking for does not exist.</p>
        <p>You may have mistyped the address or the page may have moved.</p>
        <br />
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded"
          onClick={redirectToHome}
        >
          Go to Home
        </button>
      </div>
      <img
        src={`${process.env.NODE_ENV === "production" ? basePath : ""}/assets/images/brand-logos/desktop-dark.png`}
        alt="logo"
        className="absolute bottom-10 left-1/2 transform -translate-x-1/2 w-32"
        style={{ width: "200px" }}
      />
    </div>
  );
}
